'use client';

import * as React from 'react';
import * as ProgressPrimitive from '@radix-ui/react-progress';

export type LinearProgressProps = React.ComponentProps<typeof ProgressPrimitive.Root> & {
  /**
   * The mode of the progress indicator.
   * @default 'indeterminate'
   */
  mode?: 'indeterminate' | 'determinate' | 'determinateWithoutValue';
};

/**
 * A linear progress indicator. By default, it is indeterminate.
 */
const LinearProgress = React.forwardRef<
  React.ComponentRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & LinearProgressProps
>(({ value, mode = 'indeterminate', ...props }, ref) => (
  <div className="flex items-center gap-0.5">
    <ProgressPrimitive.Root
      {...props}
      ref={ref}
      value={value}
      className="bg-color-linear-progress-background relative h-0.5 w-full overflow-hidden rounded-sm"
    >
      <ProgressPrimitive.Indicator
        className={`bg-color-primary outline-color-text-light ${mode === 'indeterminate' ? 'animate-progress transition-all duration-[2.1s]' : ''} h-full w-full flex-1 origin-top-left rounded-sm`}
        style={{ transform: `translateX(-${100 - (value ?? 0)}%)` }}
      />
    </ProgressPrimitive.Root>
    {mode === 'determinate' && (
      <span className="whitespace-nowraptext-size-body2 text-color-text-darktransparent shrink-0">
        {value}%
      </span>
    )}
  </div>
));
LinearProgress.displayName = ProgressPrimitive.Root.displayName;

export { LinearProgress };
